import { creditAssessment } from "@wayke-se/ecom";
export default (caseId, callback) => {
    creditAssessment
        .cancelSigning(caseId)
        .then(callback)
        .catch(() => callback(false));
};
